import { render, staticRenderFns } from "./GamesChats.vue?vue&type=template&id=22aadf0b&"
import script from "./GamesChats.vue?vue&type=script&lang=js&"
export * from "./GamesChats.vue?vue&type=script&lang=js&"
import style0 from "./GamesChats.vue?vue&type=style&index=0&id=22aadf0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports